export const isHigher = (list, firstValue, secondValue) => {
  const firstValueIndex = list.indexOf(firstValue);
  const secondValueIndex = list.indexOf(secondValue);

  if (firstValueIndex === -1 || secondValueIndex === -1) {
    return false;
  }

  return firstValueIndex < secondValueIndex;
};
